import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
// Angular Material Modules & Components (External)
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import {
  DxAccordionModule,
  DxBulletModule,
  DxButtonGroupModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxContextMenuModule,
  DxDateBoxModule,
  DxDrawerModule,
  DxDropDownBoxModule,
  DxFileUploaderModule,
  DxFormModule,
  DxGalleryModule,
  DxGanttModule,
  DxHtmlEditorModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxMenuModule,
  DxMultiViewModule,
  DxNumberBoxModule,
  DxPopoverModule,
  DxPopupModule,
  DxProgressBarModule,
  DxRadioGroupModule,
  DxRangeSelectorModule,
  DxSchedulerModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSliderModule,
  DxSpeedDialActionModule,
  DxSwitchModule,
  DxTabPanelModule,
  DxTagBoxModule,
  DxTemplateModule,
  DxTextBoxModule,
  DxToastModule,
  DxToolbarModule,
  DxTooltipModule,
  DxTreeViewModule,
} from 'devextreme-angular';
import { ResourceManager } from '../../../../../core/resources/src/index';
import { DevExButtonComponent } from '../../devExtreme/src/devExButton/devExButton.component';
import { DevExButtonGroupComponent } from '../../devExtreme/src/devExButtonGroup/devExButtonGroup.component';
import { DevExCheckBoxComponent } from '../../devExtreme/src/devExCheckBox/devExCheckBox.component';
import { DevExContextMenuComponent } from '../../devExtreme/src/devExContextMenu/devExContextMenu.component';
import { DevExDashBoardComponent } from '../../devExtreme/src/devExDashBoard/devExDashBoard.component';
import { DevExDatePickerComponent } from '../../devExtreme/src/devExDatePicker/devExDatePicker.component';
import { DevExDocumentInputComponent } from '../../devExtreme/src/devExDocumentInput/devExDocumentInput.component';
import { DevExDropDownComponent } from '../../devExtreme/src/devExDropDown/devExDropDown.component';
import { DevExEditorComponent } from '../../devExtreme/src/devExEditor/devExEditor.component';
import { DevExAccordionComponent } from '../../devExtreme/src/devExExpansion/devExAccordion.component';
import { DevExFloatingActionButtonComponent } from '../../devExtreme/src/devExFloatingActionButton/devExFloatingActionButton.component';
import { DevExFormComponent } from '../../devExtreme/src/devExForm/devExForm.component';
import { DevExGalleryComponent } from '../../devExtreme/src/devExGallery/devExGallery.component';
import { DevExGanttComponent } from '../../devExtreme/src/devExGantt/devExGantt.component';
// DevExtreme Modules & Components
import { DevExListBoxComponent } from '../../devExtreme/src/devExListBox/devExListBox.component';
import { DevExLoaderComponent } from '../../devExtreme/src/devExLoader/devExLoader.component';
import { DevExMenuComponent } from '../../devExtreme/src/DevExMenu/devExMenu.component';
import { DevExMessageBoxcomponent } from '../../devExtreme/src/devExMessagebox/devExMessagebox.component';
import { DevExMultiViewComponent } from '../../devExtreme/src/devExMultiView/devExMultiView.component';
import { DevExNotificationComponent } from '../../devExtreme/src/devExNotification/devExNotification.component';
import { DevExPopoverComponent } from '../../devExtreme/src/devExPopover/devExPopover.component';
import { DevExRangeSelectorComponent } from '../../devExtreme/src/devExRangeSelector/devExRangeSelector.component';
import { DevExSchedulerComponent } from '../../devExtreme/src/devExScheduler/devExScheduler.component';
import { DevExSelectBoxComponent } from '../../devExtreme/src/devExSelectBox/devExSelectBox.component';
import { DevExSliderComponent } from '../../devExtreme/src/devExSlider/devExSlider.component';
import { DevExSwitchComponent } from '../../devExtreme/src/devExSwitch/devExSwitch.component';
import { DevExTabComponent } from '../../devExtreme/src/devExTab/devExTab.component';
import { DevExTagBoxComponent } from '../../devExtreme/src/devExTagBox/devExTagBox.component';
import { DevExTreeComponent } from '../../devExtreme/src/devExTree/devExTree.component';
import { DevExWindowComponent } from '../../devExtreme/src/devExWindow/devExWindow.component';
import { DevExFileUploaderComponent } from '../../devExtreme/src/devFileUploader/devFileUploader.component';
import { DevRadioButtonComponent } from '../../devExtreme/src/devRadioButton/devRadioButton.component';
import { HighlightSearchPipe } from '../../highlightSearch.pipe';
import { MatButtonComponent } from '../../material/src/matButton/matButton.component';
import { MatCardComponent } from '../../material/src/matCard/matCard.component';
import { MatCheckBoxComponent } from '../../material/src/matCheckBox/matCheckBox.component';
import { MatChipsComponent } from '../../material/src/matChips/matChips.component';
import { MatChipsInputComponent } from '../../material/src/matChipsInput/matChipsInput.component';
import { MatContextMenuComponent } from '../../material/src/matContextMenu/matContextMenu.component';
import { MatMobileContextMenuComponent } from '../../material/src/matContextMenu/matMobileContextMenu.component';
import { MatDatepickerComponent } from '../../material/src/matDatepicker/matDatepicker.component';
import { MatDropDownComponent } from '../../material/src/matDropDown/matDropDown.component';
import { MatExpansionComponent } from '../../material/src/matExpansion/matExpansion.component';
// Internal Material components
import { MatListBoxComponent } from '../../material/src/matListBox/matListBox.component';
import { MatLoaderComponent } from '../../material/src/matLoader/matLoader.component';
import { MatPopoverComponent } from '../../material/src/matPopover/matPopover.component';
import { MatRadioButtonComponent } from '../../material/src/matRadioButton/matRadioButton.component';
import { MatRibbonComponent } from '../../material/src/matRibbon/matRibbon.component';
import { MatSelectComponent } from '../../material/src/matSelect/matSelect.component';
import { MatTabComponent } from '../../material/src/matTab/matTab.component';
import { LongPress } from '../../material/src/matTree/matTree';
import { MatTreeComponent } from '../../material/src/matTree/matTree.component';
import { MatWindowComponent } from '../../material/src/matWindow/matWindow.component';
import { AbcAutoCompleteInputModule } from './abcAutoCompleteInput/abcAutoCompleteInput.module';
import { AbcButtonComponent } from './abcButton/abcButton.component';
import { AbcButtonGroupComponent } from './abcButtonGroup/abcButtonGroup.component';
import { AbcCardComponent } from './abcCard/abcCard.component';
import { AbcCheckBoxComponent } from './abcCheckBox/abcCheckBox.component';
import { AbcChipsComponent } from './abcChips/abcChips.component';
import { AbcComboboxComponent } from './abcCombobox/abcCombobox.component';
// Services
import { AbcComponentService } from './abcComponent.service';
import { AbcContainerService } from './abcContainer.service';
import { AbcContextMenuComponent } from './abcContextMenu/abcContextMenu.component';
import { ContextMenuService } from './abcContextMenu/abcContextMenuService';
import { AbcDashBoardComponent } from './abcDashBoard/abcDashBoard.component';
import { AbcDatepickerComponent } from './abcDatepicker/abcDatepicker.component';
import { AbcDocumentInputComponent } from './abcDocumentInput/abcDocumentInput.component';
import { AbcDrawerComponent } from './abcDrawer/abcDrawer.component';
import { AbcDropDownComponent } from './abcDropDown/abcDropDown.component';
import { AbcEditorComponent } from './abcEditor/abcEditor.component';
import { AbcAccordionComponent, AbcExpansionComponent } from './abcExpansion/abcExpansion.component';
import { AbcFileUploaderComponent } from './abcFileUploader/abcFileUploader.component';
import { AbcFloatingActionButtonComponent } from './abcFloatingActionButton/abcFloatingActionButton.component';
import { AbcFormComponent } from './abcForm/abcForm.component';
import { AbcGalleryComponent } from './abcGallery/abcGallery.component';
import { AbcGanttComponent } from './abcGantt/abcGantt.component';
import { AbcGridModule } from './abcGrid/abcGrid.module';
import { AbcGridContextMenuService } from './abcGrid/abcGridContextMenu.service';
import { AbcInputModule } from './abcInput/abcInput.module';
// Abc Components
import { _AbcSplitterComponent } from '../../core/src/abc-splitter/abc-splitter.component';
import { _AbcTileNavComponent } from '../../core/src/abc-tile-nav/abc-tile-nav.component';
import { AbcListBoxComponent } from './abcListBox/abcListBox.component';
import { AbcLoaderComponent } from './abcLoader/abcLoader.component';
import { AbcMenuComponent } from './abcMenu/abcMenu.component';
import { AbcMessageBoxComponent } from './abcMessageBox/abcMessageBox.component';
import { AbcMultiViewComponent } from './abcMultiView/abcMultiView.component';
import { AbcNotificationComponent } from './abcNotification/abcNotification.component';
import { AbcPopoverComponent } from './abcPopover/abcPopover.component';
import { AbcRadioButtonComponent } from './abcRadioButton/abcRadioButton.component';
import { AbcRangeSelectorComponent } from './abcRangeSelector/abcRangeSelector.component';
import { AbcRibbonComponent } from './abcRibbon/abcRibbon.component';
import { AbcSchedulerComponent } from './abcScheduler/abcScheduler.component';
import { AbcSelectBoxComponent } from './abcSelectBox/abcSelectBox.component';
import { AbcSideNavComponent } from './abcSideNav/abcSideNav.component';
import { AbcSliderComponent } from './abcSlider/abcSlider.component';
import { AbcSplitterComponent } from './abcSplitter/abcSplitter.component';
import { AbcSwitchComponent } from './abcSwitch/abcSwitch.component';
import { AbcTabComponent } from './abcTab/abcTab.component';
import { AbcTagBoxComponent } from './abcTagBox/abcTagBox.component';
import { AbcTextAreaModule } from './abcTextArea/abcTextArea.module';
import { AbcTileNavMenuModule } from './abcTileNavMenu/abcTileNavMenu.module';
import { AbcToolBarComponent } from './abcToolbar/abcToolBar.component';
import { AbcTreeComponent } from './abcTree/abcTree.component';
import { AbcWindowComponent } from './abcWindow/abcWindow.component';

@NgModule({
  imports: [
    // HttpModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    CommonModule,
    // SharedModule,
    // SharedModule,
    RouterModule.forRoot([], { relativeLinkResolution: 'legacy' }),
    BrowserModule,
    FormsModule,
    FlexLayoutModule,
    DragDropModule,
    DxBulletModule,
    DxTemplateModule,
    DxSpeedDialActionModule,
    DxDropDownBoxModule,
    DxFileUploaderModule,
    DxDateBoxModule,
    DxAccordionModule,
    DxDrawerModule,
    DxTagBoxModule,
    DxRadioGroupModule,
    DxSchedulerModule,
    DxSwitchModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxButtonModule,
    DxGalleryModule,
    DxTextBoxModule,
    DxTreeViewModule,
    DxMultiViewModule,
    DxNumberBoxModule,
    DxContextMenuModule,
    DxTooltipModule,
    DxListModule,
    DxMenuModule,
    DxButtonGroupModule,
    DxToolbarModule,
    DxLoadIndicatorModule,
    DxPopupModule,
    DxScrollViewModule,
    DxHtmlEditorModule,
    DxTabPanelModule,
    DxRangeSelectorModule,
    DxToastModule,
    DxGanttModule,
    DxProgressBarModule,
    DxSliderModule,
    AbcGridModule,
    AbcInputModule,
    AbcTextAreaModule,
    MatMenuModule,
    MatCardModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatRadioModule,
    MatSelectModule,
    MatDialogModule,
    MatTreeModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRippleModule,
    MatSidenavModule,
    MatChipsModule,
    DxFormModule,
    DxPopoverModule,
    DxLoadPanelModule,
    _AbcTileNavComponent,
    _AbcSplitterComponent,
  ],
  providers: [AbcComponentService, AbcContainerService, ContextMenuService, AbcGridContextMenuService],
  declarations: [
    //Abc components
    AbcCardComponent,
    AbcButtonComponent,
    AbcDropDownComponent,
    AbcRibbonComponent,
    AbcSplitterComponent,
    AbcTreeComponent,
    AbcExpansionComponent,
    AbcCheckBoxComponent,
    AbcWindowComponent,
    AbcTabComponent,
    AbcComboboxComponent,
    AbcLoaderComponent,
    AbcPopoverComponent,
    AbcComboboxComponent,
    AbcAccordionComponent,
    AbcContextMenuComponent,
    AbcListBoxComponent,
    AbcRadioButtonComponent,
    AbcEditorComponent,
    AbcDatepickerComponent,
    AbcFileUploaderComponent,
    AbcSchedulerComponent,
    AbcSwitchComponent,
    AbcTagBoxComponent,
    AbcDocumentInputComponent,
    AbcSelectBoxComponent,
    AbcFloatingActionButtonComponent,
    AbcDashBoardComponent,
    AbcGalleryComponent,
    AbcSideNavComponent,
    AbcMenuComponent,
    AbcDrawerComponent,
    AbcToolBarComponent,
    AbcButtonGroupComponent,
    AbcMessageBoxComponent,
    AbcMultiViewComponent,
    AbcFormComponent,
    AbcRangeSelectorComponent,
    AbcNotificationComponent,
    AbcGanttComponent,
    AbcSliderComponent,
    AbcChipsComponent,
    //Material components
    MatCardComponent,
    MatButtonComponent,
    MatDropDownComponent,
    MatTreeComponent,
    LongPress,
    MatExpansionComponent,
    MatRadioButtonComponent,
    MatWindowComponent,
    MatCheckBoxComponent,
    MatTabComponent,
    MatLoaderComponent,
    MatPopoverComponent,
    MatSelectComponent,
    MatMobileContextMenuComponent,
    MatRibbonComponent,
    MatContextMenuComponent,
    MatListBoxComponent,
    MatDatepickerComponent,
    MatChipsComponent,
    MatChipsInputComponent,
    //Devextreme components
    DevExCheckBoxComponent,
    DevExDropDownComponent,
    DevExTreeComponent,
    DevExContextMenuComponent,
    DevExDatePickerComponent,
    DevExListBoxComponent,
    DevExAccordionComponent,
    DevExFileUploaderComponent,
    DevExSchedulerComponent,
    DevExSwitchComponent,
    DevExTagBoxComponent,
    DevExDocumentInputComponent,
    DevRadioButtonComponent,
    DevExGalleryComponent,
    DevExSelectBoxComponent,
    DevExFloatingActionButtonComponent,
    DevExDashBoardComponent,
    DevExMenuComponent,
    DevExLoaderComponent,
    DevExMessageBoxcomponent,
    DevExMultiViewComponent,
    DevExButtonGroupComponent,
    DevExFormComponent,
    DevExWindowComponent,
    DevExEditorComponent,
    DevExTabComponent,
    DevExPopoverComponent,
    DevExButtonComponent,
    DevExRangeSelectorComponent,
    DevExNotificationComponent,
    DevExGanttComponent,
    DevExSliderComponent,
    HighlightSearchPipe,
    AbcChipsComponent,
  ],
  exports: [
    AbcCardComponent,
    AbcButtonComponent,
    AbcDropDownComponent,
    AbcRibbonComponent,
    AbcSplitterComponent,
    AbcTreeComponent,
    AbcExpansionComponent,
    AbcCheckBoxComponent,
    AbcWindowComponent,
    AbcTabComponent,
    AbcComboboxComponent,
    AbcLoaderComponent,
    AbcPopoverComponent,
    AbcComboboxComponent,
    AbcAccordionComponent,
    AbcContextMenuComponent,
    AbcListBoxComponent,
    AbcRadioButtonComponent,
    AbcEditorComponent,
    AbcDatepickerComponent,
    AbcFileUploaderComponent,
    AbcTagBoxComponent,
    AbcGalleryComponent,
    AbcSchedulerComponent,
    AbcSwitchComponent,
    AbcDocumentInputComponent,
    AbcSelectBoxComponent,
    AbcFloatingActionButtonComponent,
    AbcDashBoardComponent,
    AbcSideNavComponent,
    AbcMenuComponent,
    AbcDrawerComponent,
    AbcToolBarComponent,
    AbcButtonGroupComponent,
    AbcFormComponent,
    AbcMessageBoxComponent,
    AbcMultiViewComponent,
    AbcRangeSelectorComponent,
    AbcNotificationComponent,
    AbcGanttComponent,
    AbcSliderComponent,
    AbcChipsComponent,
    FormsModule,
    ReactiveFormsModule,
    AbcInputModule,
    AbcTextAreaModule,
    AbcAutoCompleteInputModule,
    AbcTileNavMenuModule,
    HighlightSearchPipe,
    AbcGridModule,
    _AbcTileNavComponent,
  ],
})
export class AbcComponentModule {
  constructor() {
    new ResourceManager(null);
  }
}
